// extracted by mini-css-extract-plugin
module.exports = {"member":"GroupMembers_member__2O4yb","collapsed":"GroupMembers_collapsed__3ux2V","alternate":"GroupMembers_alternate__32kly"};